export default __webpack_public_path__ + "static/media/gallery-wip-emitter_04.121f7a49.jpg";